export function getDomain(host: string): string | null {
  return null;
}

export function isValid(host: string): boolean {
  return true;
}
